export const ANALYTICS_ROUTE = {
  name: 'Analytics',
  path: 'analytics',
};
